define("auth/controllers/forgot-email", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/utils/constants", "later/utils/fetch"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _tracking, _emberConcurrency, _constants, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants",0,"later/utils/fetch"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let ForgotEmailController = _exports.default = (_class = class ForgotEmailController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "profileType", _descriptor3, this);
      _defineProperty(this, "handle", '');
      _defineProperty(this, "submitForgotEmail", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (handle) {
          var _this = this;
          let profile_type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.profileType;
          let event = arguments.length > 2 ? arguments[2] : undefined;
          return function* () {
            event.preventDefault();
            try {
              yield (0, _fetch.fetch)(`/api/v2/social_profiles/email_account_owner.json`, {
                method: 'POST',
                body: {
                  social_profile: {
                    handle,
                    profile_type
                  }
                }
              });
              _this.alerts.success(_this.intl.t('alerts.authorization.forgot_email_page.success', {
                username: handle
              }));
            } catch (error) {
              _this.alerts.alert(_this.intl.t('alerts.errors.forgot_email'));
            }
          }();
        }
      }), null, "submitForgotEmail", null));
    }
    get socialPlatformOptions() {
      return [{
        value: _constants.SocialProfileType.Instagram,
        name: this.intl.t('shared_words.instagram')
      }, {
        value: _constants.SocialProfileType.Facebook,
        name: this.intl.t('shared_words.facebook')
      }, {
        value: _constants.SocialProfileType.Twitter,
        name: this.intl.t('shared_words.twitter')
      }, {
        value: _constants.SocialProfileType.Pinterest,
        name: this.intl.t('shared_words.pinterest')
      }];
    }
    get selectedOption() {
      return this.socialPlatformOptions.find(option => option.value === this.profileType);
    }
    setProfileType(option) {
      this.profileType = option.value;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "profileType", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return _constants.SocialProfileType.Instagram;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setProfileType", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setProfileType"), _class.prototype)), _class);
});